import React, { memo, useCallback, useState } from 'react'

import { ChevronDown, ChevronUp, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, shape, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const chevronSize = { height: '14px', width: '14px' }
const CHIP_CLASS = 'image-gallery-modal__setting-value image-gallery-modal__setting-value--chip cgt-caption-semibold'

// Collapsed by default: the settings only matter to someone who wants to reproduce the
// image, and open they push the similar images below the fold of the side panel.
function GenerationSettings({ settings = null }) {
  const t = useTranslation()
  const [isExpanded, setIsExpanded] = useState(false)

  const handleToggle = useCallback(() => setIsExpanded(expanded => !expanded), [])

  if (!settings) return null

  const rows = [
    ['baseModel', settings.baseModel],
    ['aspectRatio', settings.aspectRatio],
    ['style', settings.style],
    ['resolution', settings.resolution],
    ['seed', settings.seed],
  ].filter(([, value]) => value != null && value !== '')

  return (
    <div className="image-gallery-modal__settings">
      <button
        type="button"
        className="image-gallery-modal__settings-trigger"
        onClick={handleToggle}
        aria-expanded={isExpanded}
        aria-controls="image-gallery-modal-settings"
      >
        <span className="image-gallery-modal__settings-label cgt-caption">
          {t('imageGallery.modal.generationSettings')}
        </span>
        <Icon svgComponent={isExpanded ? ChevronUp : ChevronDown} size={chevronSize} color="dark" notSpaced />
      </button>
      {isExpanded && (
        <dl id="image-gallery-modal-settings" className="image-gallery-modal__settings-list">
          {settings.reference && (
            <div className="image-gallery-modal__setting">
              <dt className="image-gallery-modal__setting-label cgt-body-base-semibold">
                {t('imageGallery.modal.settings.reference')}
              </dt>
              <dd className="image-gallery-modal__setting-value">
                <img className="image-gallery-modal__reference" src={settings.reference} alt="" aria-hidden="true" />
              </dd>
            </div>
          )}
          {rows.map(([key, value]) => (
            <div className="image-gallery-modal__setting" key={key}>
              <dt className="image-gallery-modal__setting-label cgt-body-base-semibold">
                {t(`imageGallery.modal.settings.${key}`)}
              </dt>
              <dd className={CHIP_CLASS}>{value}</dd>
            </div>
          ))}
        </dl>
      )}
    </div>
  )
}

GenerationSettings.propTypes = {
  settings: shape({
    reference: string,
    baseModel: string,
    aspectRatio: string,
    style: string,
    resolution: string,
    seed: number,
  }),
}

export default memo(GenerationSettings)
